module.exports = __webpack_public_path__ + "static/14-7e065775f1c92510475135f48e87c5fd.jpg";